module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/hotdrink-right-icon-e60c961b8df19136ac460428df3c5125.svg";